import tw from "tailwind-styled-components"


export const QuizCard = tw.div `
bg-[#F9FAFB] shadow w-full md:w-[40%] text-black mx-auto flex flex-col items-center mt-10 rounded-lg
`